import { render } from "./index.vue?vue&type=template&id=7e13a6ba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7e13a6ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e13a6ba"],['__file',"src/views/Home/About/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e13a6ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e13a6ba', __exports__)) {
    console.log('reload')
    api.reload('7e13a6ba', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7e13a6ba&scoped=true", () => {
    console.log('re-render')
    api.rerender('7e13a6ba', render)
  })

}


export default __exports__